import { useMemo } from "react";

import { Alert, Stack } from "@mui/material";

import { useDutyScheduleCounselorOptions } from "@/pages/duty-schedule/hooks/useDutyScheduleCounselorOptions";
import { useDutyScheduleDetailContext } from "@/pages/duty-schedule/pages/duty-schedule-detail/DutyScheduleDetail.types";
import { DutyScheduleCounselorOverviewTable } from "@/pages/duty-schedule/pages/duty-schedule-detail/pages/counselor-overview/components/table/DutyScheduleCounselorOverviewTable";
import { useTranslation } from "@/translations";

import { buildCounselorOverviewRows, sumOverviewRows } from "./DutyScheduleCounselorOverview.utils";

export function DutyScheduleCounselorOverview() {
  const { t } = useTranslation();
  const { dutySchedule, counselorFilter } = useDutyScheduleDetailContext();
  const { counselors } = useDutyScheduleCounselorOptions();

  const { unfilledRow, counselorRows } = useMemo(
    () => buildCounselorOverviewRows(dutySchedule.slots, counselors),
    [dutySchedule.slots, counselors]
  );

  const visibleCounselorRows = useMemo(
    () => (counselorFilter == null ? counselorRows : counselorRows.filter((row) => counselorFilter.includes(row.key))),
    [counselorRows, counselorFilter]
  );
  const visibleUnfilledRow = counselorFilter == null ? unfilledRow : null;

  const totalsRow = useMemo(
    () =>
      sumOverviewRows(
        dutySchedule.columns,
        visibleUnfilledRow == null ? visibleCounselorRows : [visibleUnfilledRow, ...visibleCounselorRows]
      ),
    [dutySchedule.columns, visibleUnfilledRow, visibleCounselorRows]
  );

  return (
    <Stack flex={1} minHeight={0} gap={2}>
      <Alert severity="info">{t("dutySchedule.detail.counselorOverview.hint")}</Alert>
      <DutyScheduleCounselorOverviewTable
        columns={dutySchedule.columns}
        unfilledRow={visibleUnfilledRow}
        counselorRows={visibleCounselorRows}
        totalsRow={totalsRow}
      />
    </Stack>
  );
}
